"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const AuthClient_1 = require("./AuthClient");
class OAuthClient {
    constructor({ url, timeout = 5000 }) {
        this._authorization = null;
        this._axios = axios_1.default.create({ baseURL: url, timeout, withCredentials: true });
    }
    async bootstrap() {
        await this.token({ grant_type: 'refresh_token' });
        return {
            isSignout: !this._authorization,
            permissions: [],
        };
    }
    clear() {
        this._authorization = null;
    }
    async getAccessToken() {
        if (!this._authorization || new Date() > this._authorization.expiresAt) {
            await this.token({ grant_type: 'refresh_token' });
        }
        if (!this._authorization)
            return null;
        return this._authorization.accessToken;
    }
    async revoke() {
        try {
            await this._axios.post('/revoke');
            this._authorization = null;
        }
        catch (e) {
            const { response, message } = e;
            if (!response)
                throw new AuthClient_1.AuthClientError({ code: 'REQUEST_TIMEOUT', message });
            throw new AuthClient_1.AuthClientError({ code: 'NETWORK_ERROR', message, status: response.status });
        }
    }
    async token(data) {
        try {
            const { data: token } = await this._axios.post('/token', data, {
                validateStatus: (status) => status < 500,
            });
            if (token.error) {
                this._authorization = null;
                return false;
            }
            else {
                this._authorization = {
                    accessToken: `${token.token_type} ${token.access_token}`,
                    expiresAt: new Date(Date.now() + token.expires_in * 1000),
                };
                return true;
            }
        }
        catch (e) {
            const { response, message } = e;
            if (!response)
                throw new AuthClient_1.AuthClientError({ code: 'REQUEST_TIMEOUT', message });
            throw new AuthClient_1.AuthClientError({ code: 'NETWORK_ERROR', message, status: response.status });
        }
    }
}
exports.default = OAuthClient;
